import VueSmoothScroll from 'vue3-smooth-scroll'

export const modifyProvideApp = () => {
  return null//App
}

export const modifyApp = (app, router) => {
  app.use(VueSmoothScroll, {
    updateHistory: false
  })
}

